import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useAuthenticated } from "../auth/SessionProvider";
import { post } from "./client";
import type { AdminItem, AdminSaveRequest, AdminSaveResponse, GeneratedProctor } from "./types";

export function useAdmins() {
  const { token } = useAuthenticated();
  return useQuery({
    queryKey: ["admins", token],
    queryFn: () => post<{ items: AdminItem[] }>("/admins/list", {}, token)
  });
}

export function useSaveAdmin() {
  const { token } = useAuthenticated();
  const client = useQueryClient();
  return useMutation({
    mutationFn: (input: AdminSaveRequest) => post<AdminSaveResponse>("/admins/save", input, token),
    onSuccess: () => void client.invalidateQueries({ queryKey: ["admins"] })
  });
}

export function useGenerateProctors() {
  const { token } = useAuthenticated();
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => post<{ created: GeneratedProctor[]; skipped: number }>("/admins/generate-proctors", {}, token),
    onSuccess: () => void client.invalidateQueries({ queryKey: ["admins"] })
  });
}
